import script from "./DrawerHost.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerHost.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerHost.vue?vue&type=style&index=0&id=125994bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125994bc"]])

export default __exports__